import React, { useEffect, useState } from 'react';
import Modal from 'src/component/Global/Modal';
import NavigateToPDP from 'src/component/Global/Product/NavigateToPDP';
import DisplayLongDescriptionAndVariantMFRName from 'src/component/Product/DisplayLongDescriptionAndVariantMFRName';
import { useCartStore } from 'src/hooks/cart';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Helper from 'src/support/Helper';

const PriceMisMatch = (props) => {
    const [status, SetStatus] = useState(false);
    const { single_product, PRODUCT_PRICE, cart_params, isFrom, isManuallyAddCart } = props.data;
    const [{ }, { }, { ADD_TO_CART }] = useCartStore();
    const [__check] = useAxiosIndicatorCheck();

    useEffect(() => {
        SetStatus(true)
    }, []);

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const updateQty = async () => {

        const payload = {
            ...cart_params,
            quantity: PRODUCT_PRICE.demandQuantityOut,
            isPriceQtyMissMatch: false
        }

        await ADD_TO_CART(payload, isFrom, single_product, isManuallyAddCart);

        if (isFrom) {
            Helper.setEvars(cart_params?.ERPMFRPartNumber, "Add to Cart clicked from " + isFrom)
        }

        onHide(false);
    }

    return (
        <Modal show={status} onHide={() => { onHide() }}>
            <div className="avnet-modal modal-680">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close" data-dismiss="modal"
                        onClick={() => { onHide() }}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading">Price Mismatch Alert</h3>
                    </div>
                    <div className="m-4 mt-0">
                        <div className="justify-content-start">
                            There is a mismatch between selected Quantity and the available price tier. Please contact your local sales officer for a lower quantity pricing or confirm the adjusted quantity.
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className="inventory-table">
                            <table className="table table-outline rounded-0">
                                <thead className="bg-light">
                                    <tr>
                                        <th className="border-0 text-none font-12">Product(s)</th>
                                        <th className="border-0 text-none font-12">Requested Qty</th>
                                        <th className="border-0 text-none font-12">Adjusted Qty</th>
                                        <th className="border-0 text-none font-12">Unit Price</th>
                                    </tr>
                                </thead>
                                <tbody className="border-top-0">

                                    <tr>
                                        <td className="align-middle">
                                            <div className="inventory-product-info">
                                                <div className="inventory-product-name">
                                                    <NavigateToPDP data={{
                                                        ManufacturerName: cart_params?.ManufacturerName,
                                                        ERPMFRPartNumber: cart_params?.ERPMFRPartNumber,
                                                        ItemNumber: cart_params?.ItemNumber,
                                                    }} >
                                                        <b className='text-black'>{cart_params.ERPMFRPartNumber}</b>
                                                    </NavigateToPDP>
                                                </div>
                                                <div className="inventory-product-by">
                                                    <DisplayLongDescriptionAndVariantMFRName
                                                        currentProduct={single_product} />
                                                </div>
                                            </div>
                                        </td>
                                        <td className="align-top">
                                            <span>{cart_params.quantity}</span>
                                        </td>
                                        <td className="align-top">
                                            <span>{PRODUCT_PRICE.demandQuantityOut}</span>
                                        </td>
                                        <td className="align-top">
                                            <span><strong>{Helper.getFormatNumber(Number(PRODUCT_PRICE.marketPrice), window.mct, window.mcs, 5)}</strong></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className='text-end'><p>Item Subtotal: ({window.mct}) <strong>{Helper.getFormatNumber((parseFloat(PRODUCT_PRICE.marketPrice) * PRODUCT_PRICE.demandQuantityOut), window.mct, window.mcs, 5)}</strong> </p> </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145"
                                data-bs-toggle="modal"
                                onClick={() => { onHide(false) }}>
                                CANCEL
                            </button>
                            <button type="button" className="bs5 btn btn-primary btn-sm w145"
                                disabled={__check(['CART_OPERATION_API_CALL', 'CART_API_CALL', 'VIEW_CART_API_CALL']).status}
                                onClick={async () => { await updateQty() }}
                                data-bs-toggle="modal">
                                {__check(['CART_OPERATION_API_CALL', 'CART_API_CALL', 'VIEW_CART_API_CALL']).status ? <i className="fa fa-spinner fa-spin" /> : 'ADJUST QUANTITY'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    )
}

export default PriceMisMatch;